"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var Copyable = /*#__PURE__*/function () {
  function Copyable() {
    (0, _classCallCheck2["default"])(this, Copyable);
  }

  (0, _createClass2["default"])(Copyable, [{
    key: "copy",
    value: function copy() {
      throw new Error('Sub-class of Copyable must implement copy method.');
    }
  }], [{
    key: "isCopyable",
    value: function isCopyable(incoming) {
      return incoming instanceof Copyable;
    }
  }]);
  return Copyable;
}();

exports["default"] = Copyable;